<template>
  <div class="statistics-list" v-loading="loading">
    <div class="filter f--c">
      <!-- <el-select v-model="listParams.equipment" clearable placeholder="设备" @change="resetPage"  style="width:160px">
        <el-option label="移动设备" :value="1" />
        <el-option label="平板设备" :value="2" />
        <el-option label="桌面设备" :value="3" />
      </el-select> -->
      <el-cascader 
        v-model="categoryId"
        :options="options"
        clearable
        placeholder="品类"
        @change="handleCategoryChange"
        style="width: 300px"
        :props="{
          checkStrictly: true,
          expandTrigger: 'hover',
          value: 'categoryId',
          children: 'childList',
          label: 'name',
        }"
      ></el-cascader>
      <el-date-picker
        v-model="time"
        :clearable="false"
        type="daterange"
        align="right"
        unlink-panels
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="pickerOptions"
        :default-time="['00:00:00', '23:59:59']"
        value-format="timestamp"
        @change="handleTimeChange"
      ></el-date-picker>
      <el-input
        v-if="searchType !== 3"
        v-model="searchValue"
        class="input-with-select"
        @blur="searchPage"
        @keyup.enter.native="searchPage"
        @clear="handleClear"
        clearable
        :placeholder="searchType === 1 ? `请输入SKU/产品名称(以英文逗号隔开)` : `请输入SPU/产品名称(以英文逗号隔开)`"
        style="width: 280px;"
      ></el-input>
      <!-- <el-button @click="exportData" style="margin-left: 10px">数据导出</el-button> -->
    </div>
    <el-table
      :data="list"
      height="calc(100vh - 225px)"
      @sort-change="sortTotalTable"
      row-key=""
    >
      <el-table-column
        v-for="item in tableHead"
        :key="item.prop"
        :prop="item.prop"
        :sortable="item.isSort ? 'custom' : false"
        :label="item.label"
        :width="item.width"
        :fixed="item.isFixed"
      >
        <template v-slot="{ row }">
          <div v-if="item.prop === 'productInfo'" class="f--c" style="width:100%">
            <el-popover placement="right" width="280" trigger="hover">
              <el-image :src="row.imgUrl" fit="cover" />
              <el-image slot="reference" :src="row.imgUrl" fit="cover" style="width: 36px;height: 36px;margin-right:10px" />
            </el-popover>
            <div class="info">
              <el-tooltip class="item" effect="dark" :content="row.productName" placement="top">
                <div style="width:80%;font-size: 14px" class="ellipsis">{{ row.productName }}</div>
              </el-tooltip>
              <div v-if="searchType === 1" style="font-size: 12px;color: #454545;">
                SKU:
                <copy :text="row.skuCode" />
              </div>
              <div v-else style="font-size: 12px;color: #454545;">
                SPU:
                <copy :text="row.spuCode" />
              </div>
            </div>
          </div>
          <div v-else-if="item.prop === 'categoryFullPath'">
            <el-tooltip class="item" effect="dark" :content="row.categoryFullPath" placement="top">
              <div style="width:90%;font-size: 14px" class="ellipsis">{{ row.categoryFullPath }}</div>
            </el-tooltip>
          </div>
          <div v-else-if="item.prop === 'upDate'">
            {{ dateFormat(row[item.prop], 'yyyy-MM-dd') }}
          </div>
          <div v-else>{{ row[item.prop] }}</div>
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="userId"
        label="产品信息"
        width="400"
        :show-overflow-tooltip="true"
        fixed
      >
        <template slot-scope="{ row }">
          <div class="f">
            <el-popover placement="right" width="280" trigger="hover">
              <el-image :src="row.imgUrl" fit="cover" />
              <el-image
                slot="reference"
                :src="row.imgUrl"
                fit="cover"
                class="stock-img"
                style="width: 80px; height: 80px"
              />
            </el-popover>
            <div style="margin-left: 20px; font-size: 13px">
              <template v-if="searchType === 1">
                <div
                  style="line-height: 30px; padding-bottom: 10px; width: 260px"
                  class="ellipsis"
                >
                  {{ row.skuName }}
                </div>
                公司SKU：<copy
                  :width="'200px'"
                  :text="row.sku"
                  class="pointer"
                />
              </template>
              <template v-else>
                <div
                  style="line-height: 30px; padding-bottom: 10px; width: 260px"
                  class="ellipsis"
                >
                  {{ row.productName }}
                </div>
                SPU：<copy
                  :width="'200px'"
                  :text="row.spuCode"
                  class="pointer"
                />
              </template>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="orderAmount"
        sortable="custom"
        label="总销售额"
        min-width="130"
      >
        <template slot-scope="{ row }">
          <span>${{ row.orderAmount | round }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="visitorQty"
        sortable="custom"
        label="产品访客数"
        min-width="120"
        v-if="searchType === 2"
      ></el-table-column>
      <el-table-column
        prop="cartQty"
        sortable="custom"
        label="添加购物车"
        min-width="120"
      ></el-table-column>
      <el-table-column
        prop="wishQty"
        sortable="custom"
        label="添加心愿单"
        min-width="120"
      ></el-table-column>
      <el-table-column
        prop="createOrderQty"
        sortable="custom"
        label="买家下单数"
        min-width="120"
      ></el-table-column>
      <el-table-column
        prop="paymentOrderQty"
        sortable="custom"
        label="已付款订单"
        min-width="120"
      ></el-table-column>
      <el-table-column label="虚拟仓" min-width="120">
        <template slot-scope="scope">
          {{ scope.row.virtualWarehouseId == 1 ? "公共" : "独立站" }}
        </template>
      </el-table-column>
      <el-table-column
        prop="rate"
        sortable="custom"
        label="转化率"
        min-width="100"
        v-if="searchType === 2"
      ></el-table-column>
      <el-table-column
        prop="salesVolumeQty"
        sortable="custom"
        label="销量"
        min-width="100"
      ></el-table-column>
      <el-table-column prop="status" label="状态" width="120">
        <template slot-scope="{ row }">
          <span>{{
            row.status === 0
              ? "下架"
              : row.status === 1
              ? "上架"
              : row.status === 3
              ? "停售"
              : row.status === 4
              ? "缺货"
              : ""
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="supply"
        label="货源状态"
        width="150"
      ></el-table-column>
      <el-table-column
        prop="categoryName"
        label="类别"
        width="250"
        :show-overflow-tooltip="true"
      ></el-table-column> -->
    </el-table>
    <div class="f-b-c bg-white" style="padding: 10px">
      <div></div>
      <el-pagination
        background
        layout="total,prev, pager, next"
        :current-page="pagination.pageNumber"
        :page-size="pagination.pageSize"
        :total="total"
        @current-change="pageChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
const tableHead = {
  sku: [
    {
      prop: 'productInfo',
      label: '产品信息',
      width: '360',
      isSort: false,
      isFixed: true
    },
    {
      prop: 'categoryFullPath',
      label: '品类',
      width: '300',
      isSort: false,
      isFixed: true
    },
    {
      prop: 'color',
      label: '颜色',
      width: '140',
    },
    {
      prop: 'size',
      label: '尺码',
      width: '100',
    },
    {
      prop: 'upDate',
      label: '商品上架时间',
      width: '120',
    },
    {
      prop: 'orderSalesQty',
      label: '下单总销量',
      width: '120',
      isSort: true,
    },
    {
      prop: 'orderTotalAmout',
      label: '下单总销售额',
      width: '120',
    },
    {
      prop: 'orderPaymentSalesQty',
      label: '付款总销量',
      width: '120',
    },
    {
      prop: 'orderPaymentTotalAmout',
      label: '付款总销售额',
      width: '120',
    },
    {
      prop: 'discountAmout',
      label: '商品折扣金额',
      width: '120',
    },
    {
      prop: 'discountCouponAmout',
      label: '优惠劵折扣金额',
      width: '120',
    },
    {
      prop: 'buyAmout',
      label: '净销售额',
      width: '120',
    },
    {
      prop: 'wishQty',
      label: '添加心愿单次数',
      width: '150',
      isSort: true,
    },
    {
      prop: 'cartQty',
      label: '添加购物车次数',
      width: '150',
      isSort: true,
    },
    {
      prop: 'cartAddUserQty',
      label: '加购用户数',
      width: '120',
      isSort: true,
    },
    {
      prop: 'cartAddRate',
      label: '加购率',
      width: '120',
    },
    {
      prop: 'orderRate',
      label: '下单率',
      width: '120',
    },
    {
      prop: 'conversionRate',
      label: '转化率',
      width: '120',
    },
    {
      prop: 'cost',
      label: '成本',
      width: '120',
    },
    {
      prop: 'supplierName',
      label: '供应商',
      width: '120',
    },
    {
      prop: 'currentDevelopmentName',
      label: '开发买手',
      width: '120',
    },
    {
      prop: 'countrySalesTop1',
      label: 'TOP1销量国家',
      width: '120',
    },
    {
      prop: 'salesTop1',
      label: 'TOP1销量',
      width: '120',
    },
    {
      prop: 'countrySalesTop2',
      label: 'TOP2销量国家',
      width: '120',
    },
    {
      prop: 'salesTop2',
      label: 'TOP2销量国家',
      width: '120',
    },
    {
      prop: 'countrySalesTop3',
      label: 'TOP3销量国家',
      width: '120',
    },
    {
      prop: 'salesTop3',
      label: 'TOP3销量国家',
      width: '120',
    }
  ],
  spu: [
    {
      prop: 'productInfo',
      label: '产品信息',
      width: '360',
      isSort: false,
      isFixed: true
    },
    {
      prop: 'categoryFullPath',
      label: '品类',
      width: '300',
      isSort: false,
      isFixed: true
    },
    {
      prop: 'upDate',
      label: '商品上架时间',
      width: '120',
    },
    {
      prop: 'price',
      label: '售价',
      width: '120',
    },
    {
      prop: 'browseQty',
      label: '浏览量',
      width: '120',
      isSort: true
    },
    {
      prop: 'clickQty',
      label: '点击量',
      width: '120',
      isSort: true
    },
    {
      prop: 'clickRate',
      label: '点击率',
      width: '120',
    },
    {
      prop: 'orderSalesQty',
      label: '下单总销量',
      width: '120',
      isSort: true,
    },
    {
      prop: 'orderTotalAmout',
      label: '下单总销售额',
      width: '120',
    },
    {
      prop: 'orderPaymentSalesQty',
      label: '付款总销量',
      width: '120',
    },
    {
      prop: 'orderPaymentTotalAmout',
      label: '付款总销售额',
      width: '120',
    },
    {
      prop: 'discountAmout',
      label: '商品折扣金额',
      width: '120',
    },
    {
      prop: 'discountCouponAmout',
      label: '优惠劵折扣金额',
      width: '120',
    },
    {
      prop: 'buyAmout',
      label: '净销售额',
      width: '120',
    },
    {
      prop: 'wishQty',
      label: '添加心愿单次数',
      width: '150',
      isSort: true,
    },
    {
      prop: 'cartQty',
      label: '添加购物车次数',
      width: '150',
      isSort: true,
    },
    {
      prop: 'cartAddUserQty',
      label: '加购用户数',
      width: '120',
      isSort: true,
    },
    {
      prop: 'cartAddRate',
      label: '加购率',
      width: '120',
    },
    {
      prop: 'orderRate',
      label: '下单率',
      width: '120',
    },
    {
      prop: 'conversionRate',
      label: '转化率',
      width: '120',
    },
    {
      prop: 'cost',
      label: '成本',
      width: '120',
    },
    {
      prop: 'supplierName',
      label: '供应商',
      width: '120',
    },
    {
      prop: 'currentDevelopmentName',
      label: '开发买手',
      width: '120',
    },
    {
      prop: 'countrySalesTop1',
      label: 'TOP1销量国家',
      width: '120',
    },
    {
      prop: 'salesTop1',
      label: 'TOP1销量',
      width: '120',
    },
    {
      prop: 'countrySalesTop2',
      label: 'TOP2销量国家',
      width: '120',
    },
    {
      prop: 'salesTop2',
      label: 'TOP2销量国家',
      width: '120',
    },
    {
      prop: 'countrySalesTop3',
      label: 'TOP3销量国家',
      width: '120',
    },
    {
      prop: 'salesTop3',
      label: 'TOP3销量国家',
      width: '120',
    }
  ],
  category: [
    {
      prop: 'categoryFullPath',
      label: '品类',
      width: '300',
      isSort: false,
      isFixed: true
    },
    {
      prop: 'orderPaymentSalesQty',
      label: '付款总销量',
      width: '120',
    },
    {
      prop: 'orderPaymentTotalAmout',
      label: '付款总销售额',
      width: '120',
    },
    {
      prop: 'discountAmout',
      label: '商品折扣金额',
      width: '120',
    },
    {
      prop: 'discountCouponAmout',
      label: '优惠劵折扣金额',
      width: '120',
    },
    {
      prop: 'buyAmout',
      label: '净销售额',
      width: '120',
    },
    {
      prop: 'wishQty',
      label: '添加心愿单次数',
      width: '150',
      isSort: true,
    },
    {
      prop: 'cartQty',
      label: '添加购物车次数',
      width: '150',
      isSort: true,
    },
    {
      prop: 'cartAddUserQty',
      label: '加购用户数',
      width: '120',
      isSort: true,
    },
    {
      prop: 'cartAddRate',
      label: '加购率',
      width: '120',
    },
    {
      prop: 'orderRate',
      label: '下单率',
      width: '120',
    },
    {
      prop: 'conversionRate',
      label: '转化率',
      width: '120',
    },
    {
      prop: 'cost',
      label: '成本',
      width: '120',
    },
    {
      prop: 'supplierName',
      label: '供应商',
      width: '120',
    },
    {
      prop: 'currentDevelopmentName',
      label: '开发买手',
      width: '120',
    },
    {
      prop: 'countrySalesTop1',
      label: 'TOP1销量国家',
      width: '120',
    },
    {
      prop: 'salesTop1',
      label: 'TOP1销量',
      width: '120',
    },
    {
      prop: 'countrySalesTop2',
      label: 'TOP2销量国家',
      width: '120',
    },
    {
      prop: 'salesTop2',
      label: 'TOP2销量国家',
      width: '120',
    },
    {
      prop: 'countrySalesTop3',
      label: 'TOP3销量国家',
      width: '120',
    },
    {
      prop: 'salesTop3',
      label: 'TOP3销量国家',
      width: '120',
    }
  ]
} 

import API from "@/api";
import Copy from "../../components/Copy.vue";
import { dateFormat } from "@/utils/date";
import moment from "moment";
export default {
  components: {
    Copy,
  },
  data() {
    return {
      list: [],
      pagination: {
        pageNumber: 1,
        pageSize: 20,
      },
      total: 0,
      loading: false,
      options: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(
                start.setHours(0, 0, 0, 0),
                start.setHours(23, 59, 59, 999)
              );
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date().setHours(23, 59, 59, 999) - 24 * 3600000;
              const start = new Date().setHours(0, 0, 0, 0) - 24 * 3600000;
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近七天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近15天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 14);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近30天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "上个月",
            onClick(picker) {
              const start = new Date(
                new Date().getFullYear(),
                new Date().getMonth() - 1,
                1
              ).getTime();
              const end =
                new Date(
                  new Date().getFullYear(),
                  new Date().getMonth(),
                  0
                ).getTime() +
                24 * 3600000 -
                60;
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      categoryId: undefined,
      listParams: {
        pageNumber: 1,
        pageSize: 20,
      },
      virtualWarehouseSelectList: [],
      time: [moment().subtract("days", 6), moment()],
      searchValue: "",

      searchType: 1,
      tableHead: tableHead['sku'],
      dateFormat
    };
  },
  created() {
    if (this.$route.query.startTime) {
      this.time = [
        Number(this.$route.query.startTime),
        Number(this.$route.query.endTime),
      ];
      this.listParams.startTime = dateFormat(
        Number(this.$route.query.startTime),
        "yyyy-MM-dd"
      ).replace(/-/g, "");
      this.listParams.endTime = dateFormat(
        Number(this.$route.query.endTime),
        "yyyy-MM-dd"
      ).replace(/-/g, "");
    }
    if (this.$route.query.sort) {
      this.listParams.sortType = this.sortType(this.$route.query.sort);
      this.listParams.sort = "desc";
    }
    this.$set(this.listParams, 'startTime', dateFormat(this.time[0], 'yyyy-MM-dd').replace(/-/g, ''))
    this.$set(this.listParams, 'endTime', dateFormat(this.time[1], 'yyyy-MM-dd').replace(/-/g, ''))
    this.getCategoryList();
    this.getProductReportVirtualWarehouse();
    this.getProductReport()
  },
  computed: {
    getType() {
      return (type) => {
        switch (type) {
          case "ascending":
            return "asc";
          case "descending":
            return "desc";
          case null:
            return "desc";
        }
      };
    },
    sortType() {
      return (type) => {
        switch (type) {
          case "orderSalesQty":
            return 1;
          case "wishQty":
            return 2;
          case "cartQty":
            return 3;
          case "cartAddUserQty":
            return 4;
          case "browseQty":
            return 5;
          case "clickQty":
            return 6;
        }
      };
    },
  },
  methods: {
    //排序
    sortTotalTable({ prop, order }) {
      this.listParams.orderType = prop // this.sortType(prop);
      this.listParams.order = this.getType(order);
      this.initPage();
    },
    //列表
    getProductReport() {
      this.loading = true;
      const params = {
        ...this.listParams,
        ...this.pagination,
        searchType: this.searchType,
      };
      API.getProductReport(params)
      .then((res) => {
        this.$nextTick(() => {
          this.list = res.data.list;
          this.total = res.data.total;
          this.$tableScrollTop();
        })
      })
      .finally(() => {
        this.loading = false;
      });
    },
    pageChange(page) {
      this.pagination.pageNumber = page;
      this.getProductReport();
    },
    //导出
    exportData() {
      let form = {
        categoryId: this.listParams.categoryId,
        startTime: this.listParams.startTime,
        endTime: this.listParams.endTime,
        search: this.listParams.search,
        searchType: this.searchType,
      };
      let exportForm = {
        fileType: 2,
        taskType: 5,
        condition: JSON.stringify(form),
      };
      API.importExportFile(exportForm).then((res) => {
        if (res.code === 10000) {
          this.$message.success("用户数据导出成功,请前往导入导出中心查看进度");
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 切换tabs
    changeTabs(searchType) {
      if (searchType) {
        this.categoryId = undefined
        this.searchValue = undefined
        delete this.listParams.search;
      }
      this.searchType = searchType || 1
      this.tableHead = this.searchType === 2 ? tableHead.spu : this.searchType === 3 ? tableHead.category : tableHead.sku
      this.initPage()
    },
    initPage() {
      this.pagination.pageNumber = 1;
      this.getProductReport();
    },
    handleCategoryChange(value) {
      this.listParams.categoryId = value.slice(-1).toString();
      this.initPage();
    },
    getProductReportVirtualWarehouse() {
      API.getProductReportVirtualWarehouse().then((res) => {
        this.virtualWarehouseSelectList = res.data;
      });
    },
    handleTimeChange(time) {
      this.time = time;
      if (this.time && this.time.length === 2) {
        this.listParams.startTime = dateFormat(
          this.time[0],
          "yyyy-MM-dd"
        ).replace(/-/g, "");
        this.listParams.endTime = dateFormat(
          this.time[1],
          "yyyy-MM-dd"
        ).replace(/-/g, "");
      } else {
        this.listParams.startTime = undefined;
        this.listParams.endTime = undefined;
      }
      this.initPage();
    },
    searchPage() {
      if (this.searchValue !== "") {
        this.listParams.search = this.searchValue.split(",");
        this.initPage();
      }
    },
    handleClear() {
      delete this.listParams.search;
      this.initPage();
    },
    getCategoryList() {
      API.getCategoryList({ pageNumber: 1, pageSize: 1000 }).then((res) => {
        this.options = res.data.list;
        this.options.forEach((x) => {
          if (x.childList) {
            x.childList.forEach((y) => {
              if (y.childList) {
                y.childList.forEach((z) => {
                  delete z.childList;
                });
              }
            });
          }
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.statistics-list {
  /deep/ .el-table__fixed-body-wrapper {
    top: 59px !important;
  }
  /deep/ .el-table__fixed {
    height: calc(100vh - 237px) !important;
  }
  /deep/ .el-table__body-wrapper {
    height: calc(100vh - 286px) !important;
  }
}
.filter {
  & > div {
    margin-left: 12px;
  }
  /deep/.el-input-group {
    width: 300px;
  }
  /deep/.el-input-group__prepend {
    width: 100px;
  }
}
.range-num {
  display: inline-block;
  margin-right: 16px;
}
.update-time {
  display: inline-block;
  margin: 0 16px;
}

.avatar {
  width: 178px;
  height: 178px;
  object-fit: cover;
}
.uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
}
/deep/.el-range-separator {
  width: 20px;
}
</style>